module.exports = __webpack_public_path__ + "img/paper_upload.1a60ba67.svg";